import * as THREE from 'three'
import { CSS2DRenderer } from 'three/examples/jsm/renderers/CSS2DRenderer.js'

import Experience from './index'

export default class Renderer {
  constructor() {
    this.experience = new Experience()
    this.canvas = this.experience.canvas
    this.app = this.experience.app
    this.sizes = this.experience.sizes
    this.scene = this.experience.scene
    this.camera = this.experience.camera
    this.pinRenderer = new CSS2DRenderer()

    this.createRendererInstance()
    this.create2DRendererInstance()
  }

  create2DRendererInstance() {
    this.pinRenderer.setSize(this.sizes.width, this.sizes.height)
    this.app.appendChild(this.pinRenderer.domElement)
  }

  createRendererInstance() {
    this.renderer = new THREE.WebGLRenderer({
      canvas: this.canvas,
      alpha: true,
      antialias: true,
    })

    this.renderer.setSize(this.sizes.width, this.sizes.height)
    this.renderer.setPixelRatio(this.sizes.pixelRatio)
  }

  onResize() {
    this.renderer.setSize(this.sizes.width, this.sizes.height)
    this.renderer.setPixelRatio(this.sizes.pixelRatio)
    this.pinRenderer.setSize(this.sizes.width, this.sizes.height)
  }

  update() {
    this.pinRenderer.render(this.scene, this.camera.camera)
    this.renderer.render(this.scene, this.camera.camera)
  }
}
